module.exports = __webpack_public_path__ + "img/logo.68037756.png";